import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

import Header from './Header';
import logo from './images/icons/logo.JPG'; // Import your image here

const ModalViewPlots = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;

    let userCompanyID = localStorage.getItem('companyID')
  if(userCompanyID === 'Admin'){
   userCompanyID = 1;
  }
  userCompanyID = JSON.parse(userCompanyID)

  let userID = localStorage.getItem('userID')
  if(userID === 'Admin'){
    userID = 1;
  }
  userID = JSON.parse(userID)

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-ZM', { style: 'currency', currency: 'ZMW' }).format(amount);
  };

  const formatCurrencyTable = (amount) => {
    // Convert amount to a number if it's not already
    const number = typeof amount === 'number' ? amount : parseFloat(amount);
    return new Intl.NumberFormat('en-ZM', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(number);
  };

  const [plotsData, setPlotsData] = useState([]);
  //const [searchInput, setSearchInput] = useState('');
  const tableRef = useRef(null);

  const [searchValuePlots, setSearchValuePlots] = useState(''); // Search value

 
  const [entriesValuePlots, setEntriesValuePlots] = useState(5);
  useEffect(() => {
    fetchDataForTablePlotsCustomers();
  }, [entriesValuePlots]);

  const fetchDataForTablePlotsCustomers = async () => {
    const formData = new FormData();
    formData.append("apiType", 'viewPlots');
    formData.append('userCompanyID', userCompanyID); // replace with your actual userCompanyID
    try {
      const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
      //alert('API Response Data for Table: ' + JSON.stringify(response.data));
/*
      const processedData = response.data.map(row => ({
        ...row,
        amountPaid: parseFloat(row.amountPaid) || 0
      }));
*/
setPlotsData(response.data);
      //alert('Processed Data for Table: ' + JSON.stringify(processedData));

      setTimeout(() => {
        const table = $('#tableViewPlots').DataTable({
          footerCallback: function (row, data, start, end, display) {
            const api = this.api();

            const pageTotal = api
              .column(11, { page: 'current' })
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Page Total: ' + pageTotal);

            $(api.column(11).footer()).html(formatCurrency(pageTotal.toFixed(2)));

            const overallTotal = api
              .column(11)
              .data()
              .reduce((a, b) => a + (parseFloat(b) || 0), 0);

            //alert('Overall Total: ' + overallTotal);

            $('#totalOverallPlotsCustomers').html(overallTotal.toFixed(2));
          },
          retrieve: true,
          pageLength: entriesValuePlots,
          lengthMenu: [5, 10, 25, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 15000, 20000, 50000, 100000, 500000, 1000000],
          initComplete: function () {
            const api = this.api();
            setSearchValuePlots(api.search());
            setEntriesValuePlots(api.page.len());

            api.on('search.dt', function () {
              setSearchValuePlots(api.search());
            });

            api.on('length.dt', function () {
                setEntriesValuePlots(api.page.len());
            });
          }
        });

        //addTableButtons(table);
      }, 1000);
    } catch (error) {
      //alert('Error fetching data for table: ' + error);
    }
  };
  /**********Codes For DataTables Ends Here****************/


  const handleExportPDF = () => {
    const doc = new jsPDF('landscape');
    const tableRows = [];
    const filteredData = plotsData.filter(plot =>
      Object.values(plot).some(value =>
        value.toString().toLowerCase().includes(searchValuePlots.toLowerCase())
      )
    );
  
    let plotPrice = 0.0;
    let plotPricesNew = 0.0;
    let paidToNHEF = 0.0;
    let totalAmountPaid = 0.0;
  
    filteredData.forEach((plot, index) => {
      plotPrice += parseFloat(plot.plotPrice) || 0;
      plotPricesNew += parseFloat(plot.plotPricesNew) || 0;
      paidToNHEF += parseFloat(plot.paidToNHEF) || 0;
      totalAmountPaid += parseFloat(plot.totalAmountPaid) || 0;
  
      tableRows.push([
        index + 1,
        plot.businessLocationName,
        plot.plotNumber,
        plot.plotNumbers,
        plot.plotArea,
        plot.plotAreas,
        formatCurrencyTable(plot.plotPrice),
        formatCurrencyTable(plot.plotPrices),
        formatCurrencyTable(plot.monthlyInstallments),
        formatCurrencyTable(plot.twentyPercentDeposit),
        formatCurrencyTable(plot.paidToNHEF),
        formatCurrencyTable(plot.totalAmountPaid),
        plot.contributionsFrequency,
        plot.plotStatus
      ]);
    });
  
    const tableFootTemplate = [['', '', '', '', '', '', '', '', '', '', '']]; // Empty foot for all pages
  
    doc.autoTable({
      head: [['SN', 'Location', 'Old Plot #', 'New Plot #', 'Old Plot Area', 'New Plot Area', 'Old Plot Price', 'New Plot Price', 'Monthly Installments', '20% Deposit', 'Paid To NHEF', 'Total Contributions', 'Contributions Frequency', 'Status']],
      body: tableRows,
      //foot: tableFootTemplate,
      didDrawPage: (data) => {
        // Add page number
        const pageCount = doc.internal.getNumberOfPages();
        const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  
        doc.setFontSize(10);
        doc.text(`Page ${data.pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 10);
  
        // Check if it's the last page and add the footer figures
        if (data.pageNumber === pageCount) {
          const finalY = pageHeight - 20; // Position footer just above the bottom margin
  
          // Draw the footer figures manually on the last page
          doc.setFontSize(12);
          const xPositions = {
            plotPrice: 15, // Adjust these values according to your table layout
            plotPrices: 25, // Adjust these values according to your table layout
            paidToNHEF: 100,
            totalAmountPaid: 200
          };
  
          doc.text(`Old Total Plot Prices: ${formatCurrency(plotPrice.toFixed(2))}`, xPositions.plotPrice, finalY);
          doc.text(`New Total Plot Prices: ${formatCurrency(plotPricesNew.toFixed(2))}`, xPositions.plotPrices, finalY);
          doc.text(`Total Paid To NHEF: ${formatCurrency(paidToNHEF.toFixed(2))}`, xPositions.paidToNHEF, finalY);
          doc.text(`Total Amount Paid: ${formatCurrency(totalAmountPaid.toFixed(2))}`, xPositions.totalAmountPaid, finalY);
        }
      },
      margin: { bottom: 30 },
    });
  
    doc.save('plots.pdf');
  };
  
  

  return (
    <>
    <Header />
   
  <main class="bg-white">   
  <hr />
   <div className="container-fluid mt-5" style={{ overflowX: 'auto' }}>
      
      <button onClick={handleExportPDF} className="btn btn-primary mb-3">PDF</button>
      <table id="tableViewPlots" className="table table-striped table-bordered table-hover table-sm">
        <thead className="ocean blue-gradient white-text">
          <tr>
            <th className="font-weight-bold"><strong>SN</strong></th>
            <th className="font-weight-bold"><strong>Location</strong></th>
            <th className="font-weight-bold"><strong>Old Plot #</strong></th>
            <th className="font-weight-bold"><strong>New Plot #</strong></th>
            <th className="font-weight-bold"><strong>Old Plot Area (M2)</strong></th>
            <th className="font-weight-bold"><strong>New Plot Area (M2)</strong></th>
            <th className="font-weight-bold"><strong>Old Plot Price</strong></th>
            <th className="font-weight-bold"><strong>New Plot Price</strong></th>
            <th className="font-weight-bold"><strong>Monthly</strong></th>
            <th className="font-weight-bold"><strong>20% Deposit</strong></th>
            <th className="font-weight-bold"><strong>Paid To NHEF</strong></th>
            <th className="font-weight-bold"><strong>Total Paid</strong></th>
            <th className="font-weight-bold"><strong>Contributions Frequency</strong></th>
            <th className="font-weight-bold"><strong>Status</strong></th>
          </tr>
        </thead>
        
        <tbody>
  {plotsData.map((plot, index) => 
    {
    //console.log('Plot Data:', plot); // Inspect in browser console
  return(
    <tr key={plot.plotsID} id={plot.plotsID}>
      <td>{index + 1}</td>
      <td>{plot.businessLocationName}</td>
      <td>{plot.plotNumber}</td>
      <td>
        {plot.businessLocationID === "3" 
          ? plot.plotNumber 
          : plot.plotNumbers}
      </td>
      <td>{plot.plotArea}</td>
      <td>
      {plot.businessLocationID === "3" 
          ? plot.plotArea 
          : plot.plotAreas}
        </td>
      
      <td>{plot.plotPrice}</td>
      <td>
      {plot.businessLocationID === "3" 
          ? plot.plotPrice
          : plot.plotPrices}
      </td>
      <td>{plot.monthlyInstallments}</td>
      <td>{plot.twentyPercentDeposit}</td>
      <td>{plot.paidToNHEF}</td>
      <td>{plot.totalAmountPaid}</td>
      <td>{plot.contributionsFrequency}</td>
      <td>{plot.plotStatus}</td>
    </tr>
  )
  }
)
}
</tbody>

        <tfoot className='form-header text-center black-text'>
          <tr>
            <th></th>
            <th>Total Contributions</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </tfoot>
      </table>
</div>
      </main>
    </>
  );
};

export default ModalViewPlots;
